<template>
    <div class="text-center">
        <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :close-on-click="false"
            :nudge-width="400"
            :max-width="$isDesktop() ? '400px' : '90%'"
            max-height="90%"
            bottom
            left
            origin="top right"
            transition="scale-transition"
            offset-y>
            <template v-slot:activator="{ on }">
                <v-btn raised elevation="1" min-width="0" text v-on="on" @dblclick="onDblClick_Refresh">
                    <v-icon>mdi-filter-outline</v-icon>
                </v-btn>
            </template>

            <v-card>
                <v-card-title class="headline">
                    <p class="pl-7 mb-8 mt-8">
                        Filter Flights
                    </p>
                </v-card-title>

                <v-form>
                    <!-- >>> Form, Fields -->
                    <v-list>
                        <v-list-item>
                            <v-combobox
                                v-model="aircrafts"
                                :items="get_AircraftConfigs_complaintManagement"
                                item-text="code"
                                item-value="idAircraft"
                                label="Select one/more Aircrafts(s)"
                                prepend-icon="mdi-home"
                                clearable
                                multiple
                                small-chips />
                        </v-list-item>

                        <v-list-item class="mt-2">
                            <v-icon style="margin-right:11px;margin-left:3px;margin-bottom:auto;margin-top:20px;">
                                mdi-calendar
                            </v-icon>
                            <div style="width:100%;">
                                <p style="color:rgba(0,0,0,.87);font-size:0.7rem;" class="ma-0 mb-n1 text-left">
                                    Day
                                </p>
                                <v-chip-group
                                    v-model="input_Days"
                                    pre
                                    multiple
                                    active-class="sdr-chip--active">
                                    <v-chip v-for="day in items_Days" :key="day.text" small class="mx-1" :value="day.value">
                                        {{ day.text }}
                                    </v-chip>
                                </v-chip-group>
                                <v-divider class="mb-4 mt-1 grey lighten-1" />
                            </div>
                        </v-list-item>

                        <div style="padding: 0 20px; display: flex; margin-top: 16px;">
                            <v-switch v-model="input_Deleted" style="margin: 0; padding: 0;" label="Show deleted flights" />
                        </div>
                    </v-list>


                    <!-- >>> Action Buttons -->
                    <v-card-actions style="position:sticky;bottom:0px;background-color:white;padding-bottom:0.71rem;">
                        <v-spacer />
                        <v-btn style="width:120px; font-size:16px;" depressed elevation="1" outlined color="#ab3b7a" @click="onClick_Filter_Close()">
                            Cancel
                        </v-btn>
                        <v-btn class="mr-2" style="width:120px; font-size:16px;" depressed elevation="1" color="primary" @click="onClick_Filter_DaysAndCo(true)">
                            Filter
                        </v-btn>
                    </v-card-actions>
                    <!-- <<< Action Buttons -->
                </v-form>
            </v-card>
        </v-menu>
    </div>
</template>


<script>
    import Vue from 'vue';
    import { mapActions, mapGetters } from 'vuex';
    import { eventBus } from '../../../../../main';
    import dayjs from 'dayjs';
        import {
        CONF_CLIENT
    } from '../../../../../config';


    export default {
        name: 'FlightsFilterMenue',

        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                menu: false,
                visibleDays: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'So'],
                items_visibleDays: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'So'],
                aircrafts: [],
                items_aicrafts: [],
                input_Days: [1, 2, 3, 4, 5, 6, 0],
                items_Days: [
                    { text: '1', value: 1, backendValue: 'MONDAY' },
                    { text: '2', value: 2, backendValue: 'TUESDAY' },
                    { text: '3', value: 3, backendValue: 'WEDNESDAY' },
                    { text: '4', value: 4, backendValue: 'THURSDAY' },
                    { text: '5', value: 5, backendValue: 'FRIDAY' },
                    { text: '6', value: 6, backendValue: 'SATURDAY' },
                    { text: '7', value: 0, backendValue: 'SUNDAY' }
                ],
                input_Types: ['F', 'C', 'E', 'P', 'NULL'],
                items_Types: [
                    { text: 'Ferry', value: 'F' },
                    { text: 'Commercial', value: 'C' },
                    { text: 'Technical', value: 'E' },
                    { text: 'Positional', value: 'P' },
                    { text: '-', value: 'NULL' }
                ],
                input_Deleted: false,
                // >>> --------------------------
                backupFilterObject: {
                    aircrafts: [],
                    input_Days: [],
                    input_Deleted: false
                }

            };

        }, // eo funtion data()
        /* <<< ****************************************************************/



        /* >>> ****************************************************************/ /* Computed */
		computed: {

			...mapGetters([
                'get_AircraftConfigs',
                'get_AircraftConfigs_complaintManagement',
                'get_flights_StartDate',
                'get_flights_EndDate'
            ])

		}, // eo computed{}
		/* <<< ****************************************************************



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
		created: function() {

            const me = this;


            me.$toc('>>> views/flights/flights/components/core/FilterMenue.vue >>> created');
            me.aircrafts = me.get_AircraftConfigs;
            //me.aircrafts = CONF_CLIENT === 'Sundair' ? me.aircraftsSundair  : me.aircraftsFlyAir41;

            eventBus.$on('filtereventflightnoleg', me.onEmit_Filter_LegOrFlightNo);
            eventBus.$on('menuopen', me.onEmit_menuOpen);

            me.onClick_Filter_DaysAndCo(false); // @startup

		}, // eo function created()


        /***********************************************************************
        * Lifecyclehook::destroyed
        *
        * Desc:
        * Note:
        *
        */
		destroyed: function() {

            const me = this;


            me.$toc('>>> views/flights/flights/components/core/FilterMenue.vue >>> destroyed');
            eventBus.$off('filtereventflightnoleg', me.onEmit_Filter_LegOrFlightNo);
            eventBus.$off('menuopen', me.onEmit_menuOpen);

		}, // eo function destroyed()
		/* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_set_FilterTerms_DaysAndCo',
                'actn_set_FilterTerms_LegsAndFlightNo'
            ]),


            /*******************************************************************
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onRefresh()
            *
            * Desc:
            * Note: Not used currently.
            *
            */
            onDblClick_Refresh: function() {

                const me = this;


                me.$toc('>>> views/flights/flights/components/core/FilterMenue.vue >>> onDblClick_Refresh');
                me.menu = false;

            }, // eo function onDblClick_Refresh()


            /*******************************************************************
			* onClick_Filter_DaysAndCo()
			*
			* Desc: Close Date Range Menu and trigger Call.
            * Note: Params for Call, dateRange for Schedluer.
            *
			*/
			onClick_Filter_DaysAndCo: function(reloadEvents) {

                const me = this;
                let filterTerms = null,
                    params = null,
                    dateRange = null;


                me.$toc('>>> views/flights/flights/components/core/FilterMenue.vue >>> onClick_Filter_DaysAndCo');
                // check if reload is necessary
                if (me.backupFilterObject.aircrafts === me.aircrafts &&
                    me.backupFilterObject.input_Days === me.input_Days) {
                        reloadEvents = false;
                }
                this.backupLocalState();

                dateRange = {
                    startDate: dayjs(me.get_flights_StartDate),
                    endDate: dayjs(me.get_flights_EndDate)
                };

                filterTerms = {

                    // aircrafts: aircraftsFromCarrier.map(a => {
                    //     // necessary to look for equal codes because
                    //     // id & idAircraft are different on LIVE and TEST
                    //     const foundAircraftConfig = me.get_AircraftConfigs.find(b => a.code === b.code);
                    //     if (!Vue.prototype.$isEmpty(foundAircraftConfig)) {
                    //         return foundAircraftConfig.idAircraft;
                    //     }
                    // }),
                    aircrafts: me.aircrafts.map(aircraft => {
                        return aircraft.idAircraft;
                    }),
                    days: me.input_Days,
                    types: me.input_Types,
                    deleted: me.input_Deleted
                };

                params = {
                    flightNo: null,
                    from: dayjs(me.get_flights_StartDate).format('YYYY-MM-DDT00:00:00[Z]'), //"2021-04-30T00:00:01Z"
                    fromAptCode: null,
                    idFlight: null,
                    to: dayjs(me.get_flights_EndDate).format('YYYY-MM-DDT23:59:59[Z]'), //"2021-04-30T23:59:59Z"
                    toAptCode: null,
                    DOW: me.input_Days.map((day) => {
                        return me.items_Days.find(i => i.value === day).backendValue;
                    }),
                    idAircraftConfig: me.aircrafts.map(aircraft => {
                        return aircraft.id;
                    })
                    // idAircraftConfig: aircraftsFromCarrier.map(a => {
                    //     // necessary to look for equal codes because
                    //     // id & idAircraft are different on LIVE and TEST
                    //     const foundAircraftConfig = me.get_AircraftConfigs.find(b => a.code === b.code);
                    //     if (!Vue.prototype.$isEmpty(foundAircraftConfig)) {
                    //         return foundAircraftConfig.id;
                    //     }

                    //     // >>> CAR: added undefined as default return value,
                    //     // otherwise this function returns null and map
                    //     // will create an array like [null, null, null, ...]
                    //     return undefined;
                    //     // <<< CAR added undefined
                    // })

                };

                me.actn_set_FilterTerms_DaysAndCo({ dateRange, reloadEvents, params, filterTerms });
                me.menu = false;

            }, // eo function onClick_Filter_DaysAndCo()


            /*******************************************************************
			* onClick_Filter_Close()
			*
			* Desc:
            * Note:
            *
			*/
            onClick_Filter_Close: function() {

                const me = this;


                me.$toc('>>> views/flights/flights/components/core/FilterMenue.vue >>> onClick_Filter_Close');
                this.menu = false;
                this.recoverLocalState();

            }, // function onClick_Filter_Close()



            /*******************************************************************
            * Listeners: Emit
            *******************************************************************/
            /*******************************************************************
			* onEmit_Filter_LegOrFlightNo()
			*
			* Desc:
            * Note:
            *
			*/
			onEmit_Filter_LegOrFlightNo: function(payload) {

                const me = this;
                const filterTerms = {
                    leg: '',
                    flightNo: ''
                };


                me.$toc('>>> views/flights/flights/components/core/FilterMenue.vue >>> onEmit_Filter_LegOrFlightNo');
                if (payload) {
                    filterTerms[payload.type] = payload.value;
                }


                me.actn_set_FilterTerms_LegsAndFlightNo({ filterTerms });

            }, // eo function onEmit_Filter_LegOrFlightNo()


            /*******************************************************************
			* onEmit_menuOpen()
			*
			* Desc: Close menu if another menu opens.
            * Note: This is necessary, because of v-menu prop
            * Note: ":close-on-click="false""
            *
			*/
            onEmit_menuOpen: function() {

                const me = this;


                me.$toc('>>> views/flights/flights/components/core/FilterMenue.vue >>> onEmit_menuOpen');
                me.menu = false;

            }, // eo function onEmit_menuOpen()



            /*******************************************************************
            * Utilities
            *******************************************************************/
            /*******************************************************************
			* backupLocalState()
			*
			* Desc:
            * Note:
            *
			*/
            backupLocalState: function() {

                const me = this;


                me.$toc('>>> views/flights/flights/components/core/FilterMenue.vue >>> backupLocalState');
                me.backupFilterObject.aircrafts = me.aircrafts;
                me.backupFilterObject.input_Days = me.input_Days;
                me.backupFilterObject.input_Deleted = me.input_Deleted;

            }, // eo function backupLocalState()


            /*******************************************************************
			* recoverLocalState()
			*
			* Desc:
            * Note:
            *
			*/
            recoverLocalState: function() {

                const me = this;


                me.$toc('>>> views/flights/flights/components/core/FilterMenue.vue >>> recoverLocalState');
                me.aircrafts = me.backupFilterObject.aircrafts;
                me.input_Days = me.backupFilterObject.input_Days;
                me.input_Deleted = me.backupFilterObject.input_Deleted;

            } // eo function recoverLocalState()


        } // eof methods()
        /* <<< ****************************************************************/

    };
</script>

<style>
    .v-select.v-select--chips.v-select--chips--small .v-select__selections {
        min-height: 0px !important; /* 26px */
    }

    .v-label {
        font-size: 14px !important; /* 16px */
    }

    .v-select.v-select--chips input {
        min-height: 42px;
    }

    .v-btn__content {
        font-size: 12px;
    }

    .v-card {
        margin-top: 0px;
        margin-bottom: 0px;
    }
</style>
